import { render, staticRenderFns } from "./Protocolos.vue?vue&type=template&id=42e083e6&"
import script from "./Protocolos.vue?vue&type=script&lang=js&"
export * from "./Protocolos.vue?vue&type=script&lang=js&"
import style0 from "./Protocolos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports